import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import PrepaymentWaiverModalUI from './PrepaymentWaiverModalUI.js'
import { nb } from 'date-fns/locale'

class PrepaymentWaiverModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            status: null,
            leviedAmount: this.props.prepayment ? this.props.prepayment.leviedAmountF : '',
            leviedReason: this.props.prepayment ? this.props.prepayment.leviedReason : '',
            waivedAmount: this.props.prepayment ? this.props.prepayment.waivedAmountF : '',
            waivedReason: this.props.prepayment ? this.props.prepayment.waivedReason : '',
            leviedAmountError: null,
            leviedReasonError: null,
            waivedAmountError: null,
            waivedReasonError: null
        }
    }

    render() {
        return (
            <PrepaymentWaiverModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                updateMode={this.props.updateMode}
                submitted={this.state.submitted}
                status={this.state.status}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.onCancelClick}
                // form fields
                leviedAmount={this.state.leviedAmount}
                onLeviedAmountChange={(event) => { this.setState({ leviedAmount: event.target.value }) }}
                leviedAmountError={this.state.leviedAmountError}
                setLeviedAmountError={(error) => { this.setState({ leviedAmountError: error }) }}
                //
                leviedReason={this.state.leviedReason}
                onLeviedReasonChange={(event) => { this.setState({ leviedReason: event.target.value }) }}
                leviedReasonError={this.state.leviedReasonError}
                setLeviedReasonError={(error) => { this.setState({ leviedReasonError: error }) }}
                //
                waivedAmount={this.state.waivedAmount}
                onWaivedAmountChange={(event) => { this.setState({ waivedAmount: event.target.value }) }}
                waivedAmountError={this.state.waivedAmountError}
                setWaivedAmountError={(error) => { this.setState({ waivedAmountError: error }) }}
                //
                waivedReason={this.state.waivedReason}
                onWaivedReasonChange={(event) => { this.setState({ waivedReason: event.target.value }) }}
                waivedReasonError={this.state.waivedReasonError}
                setWaivedReasonError={(error) => { this.setState({ waivedReasonError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.post(this.props.context,
            `/api/su/loans/${this.props.loan.loanId}/prepayments/waiver`,
            this.onSubmitCallback, {
            leviedAmountF: this.state.leviedAmount,
            leviedReason: this.state.leviedReason,
            waivedAmountF: this.state.waivedAmount,
            waivedReason: this.state.waivedReason
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    onCancelClick = () => {
        this.setState({
            errorList: null,
            submitted: false,
        })
        this.props.onCancelClick()
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default PrepaymentWaiverModalSF
